import React, { useCallback, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import Loading from "../../Components/loading";
import DraggableQuestion from "./DraggableQuestion";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import bgImage from "../../assets/images/bg-img.jpg";
import { FaSave } from "react-icons/fa";

import toast from "react-hot-toast";

const SetUpInterview = () => {
  const defaultQuestions = [];

  const [loading, setLoading] = useState(false);
  const [regenLoading, setRegenLoading] = useState(false);
  const [apiCall, setApiCall] = useState(1);
  const [position, setPosition] = useState();
  const [minExperience, setMinExperience] = useState();
  const [maxExperience, setMaxExperience] = useState();
  const [technologies, setTechnologies] = useState();
  const [dummyGeneratedQuestions, setDummyGeneratedQuestions] = useState([]);
  const [shouldReset, setShouldReset] = useState(false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id"); // Get the 'id' from the UR
  const candidateID = searchParams.get("candidate_id"); // Get the 'Candidate id' from the UR
  const [showSave, setShowSave] = useState(false);

  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const navigate = useNavigate(); // Initialize navigation

  const nextStep = () => {
    if (id) {
      navigate(`/setup-coding?id=${id}`);
    }
  };

  const prevStep = () => {
    if (id) {
      navigate(`/setup-mcq?id=${id}`);
    }
  };

  useEffect(() => {
    if (shouldReset) {
      resetQuestions();
    }
  }, [shouldReset]);

  function generateHashSession() {
    const now = new Date();

    // Format: YYYY-MM-DD_HH-MM-SS
    const timestamp = now.toISOString().replace(/[-:.TZ]/g, "_");

    // Generate a random number for uniqueness
    const randomPart = Math.floor(Math.random() * 1e12);

    return `${timestamp}_${randomPart}`;
  }

  const getdummyGeneratedQuestions = async () => {
    setLoading(true);
    try {
      const data = {
        input_content: `Create two interview questions with answers for a candidate proficient in ${
          technologies ? technologies : "React and Node.js"
        }, having experience between ${
          minExperience ? minExperience : "2"
        } and ${
          maxExperience ? maxExperience : "5"
        } years, and applying for the ${
          position ? position : "Software Engineer"
        } role. Ensure the answer is fully printed without truncation.`,
        api_call: apiCall,
        hash_session: generateHashSession(),
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/fetch_questions`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      setDummyGeneratedQuestions(response?.data?.question_answer_pairs);
      addGenerateMoreQuestions(response?.data?.question_answer_pairs);
      setShowRegenerate(true);
      console.log(response, "****response*****");
      setApiCall(apiCall + 1);
    } catch (error) {
      console.log(error, "*****Error******");
      toast.error("Failed to fetch questions", {
        style: { backgroundColor: "red", color: "white" },
      });
    } finally {
      setLoading(false);
      setShowSave(true);
    }
  };

  const [questions, setQuestions] = useState(defaultQuestions);
  const [customQuestions, setCustomQuestions] = useState([]);
  const [generateMoreQuestions, setGenerateMoreQuestions] = useState([]);
  const [showRegenerate, setShowRegenerate] = useState(false);
  const [addMoreLoading, setAddMoreLoading] = useState(false); // New state

  const addCustomQuestion = () => {
    setCustomQuestions([]);
    setGenerateMoreQuestions([
      ...generateMoreQuestions,
      ...customQuestions,
      { question: "", answer: "" },
    ]);
    setShowRegenerate(true);
    setShowSave(true);
  };

  const removeCustomQuestion = (index) => {
    const updatedQuestions = customQuestions.filter((_, idx) => idx !== index);
    setCustomQuestions(updatedQuestions);
    setShowSave(true);
  };

  const addGenerateMoreQuestions = (dummyQuestions) => {
    console.log(dummyGeneratedQuestions, "*****dummyGeneratedQuestions*****");
    dummyQuestions
      ? setGenerateMoreQuestions([...generateMoreQuestions, ...dummyQuestions])
      : setGenerateMoreQuestions([
          ...generateMoreQuestions,
          ...dummyGeneratedQuestions,
        ]);
  };

  const handleCustomChange = (index, field, value, type) => {
    const updatedQuestions = [
      ...(type === "custom" ? customQuestions : generateMoreQuestions),
    ];
    updatedQuestions[index][field] = value;
    if (type === "custom") {
      setCustomQuestions(updatedQuestions);
    } else {
      setGenerateMoreQuestions(updatedQuestions);
    }
    setShowRegenerate(true);
    setShowSave(true);
  };

  const regenerateQuestions = async () => {
    setRegenLoading(true);
    try {
      setDummyGeneratedQuestions([]);
      setGenerateMoreQuestions([]);

      const data = {
        input_content: `Generate two fresh and non-repetitive interview questions with detailed answers tailored for a candidate skilled in ${
          technologies ? technologies : "React and Node.js"
        }, having experience between ${
          minExperience ? minExperience : "2"
        } and ${
          maxExperience ? maxExperience : "5"
        } years, and applying for the ${
          position ? position : "Software Engineer"
        } role. Ensure the answer is fully printed without truncation.`,
        api_call: apiCall,
        hash_session: generateHashSession(),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/fetch_questions`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      setDummyGeneratedQuestions(response?.data?.question_answer_pairs);
      setGenerateMoreQuestions(response?.data?.question_answer_pairs);
      setApiCall(apiCall + 1);
    } catch (error) {
      console.error(error, "*****Error in Regenerating Questions*****");
      toast.error("Failed to regenerate questions", {
        style: { backgroundColor: "red", color: "white" },
      });
    } finally {
      setRegenLoading(false);
      setShowSave(true);
    }
  };

  const removeGeneratedQuestion = (index) => {
    const updatedQuestions = generateMoreQuestions.filter(
      (_, idx) => idx !== index
    );
    setGenerateMoreQuestions(updatedQuestions);
  };

  const resetQuestions = () => {
    setDummyGeneratedQuestions([]);
    setGenerateMoreQuestions([]);
    setShowRegenerate(false);
    setShouldReset(false);
  };
  const moveQuestion = useCallback((fromIndex, toIndex) => {
    setGenerateMoreQuestions((prev) => {
      const updatedQuestions = [...prev];
      const [movedItem] = updatedQuestions.splice(fromIndex, 1);
      updatedQuestions.splice(toIndex, 0, movedItem);
      return updatedQuestions;
    });
  }, []);

  useEffect(() => {
    getJob();
  }, []);

  const getJob = async () => {
    try {
      setLoading(true);
      console.log(id);

      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/get_job?jd_id=${id}`,
        {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }
      );
      setMaxExperience(response?.data?.job?.max_experience);
      setMinExperience(response?.data?.job?.min_experience);
      setPosition(response?.data?.job?.job_title);
      setTechnologies(response?.data?.job?.required_skills);
      console.log("Job Data:", response.data);
    } catch (err) {
      console.error("Error fetching job:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getQueAns();
  }, []);

  const getQueAns = async () => {
    try {
      setLoading(true);
      console.log(id);

      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/get_questions_answers?jd_id=${id}`,
        {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }
      );
      setGenerateMoreQuestions(response?.data?.qa_pairs);
      setShowRegenerate(true);
      console.log(response, "*******Response*********");
    } catch (err) {
      console.error("Error fetching question and answers:", err);
    } finally {
      setLoading(false);
      setShowSave(true);
    }
  };

  const AddQueAns = async () => {
    const payload = {
      question_answer_pairs: generateMoreQuestions,
      interview_url: `http://localhost:3000/ai-interview?id=${id}&candidate_id=${candidateID}`,
    };
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/add_qna?jd_id=${id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setIsSaveClicked(true);
    } catch (error) {
      toast.error(
        error?.response?.data?.error
          ? error?.response?.data?.error
          : "Something went wrong",
        {
          style: { backgroundColor: "red", color: "white" },
        }
      );
      console.error("Error while saving questions:", error);
    } finally {
      setLoading(false);
      setIsSaveClicked(true);
      setShowSave(false);
    }
  };

  const addMoreQuestions = async () => {
    setAddMoreLoading(true);
    setLoading(true);
    try {
      const data = {
        input_content: `Generate two additional unique interview questions with detailed answers for a candidate proficient in ${
          technologies ? technologies : "React and Node.js"
        }, having experience between ${
          minExperience ? minExperience : "2"
        } and ${
          maxExperience ? maxExperience : "5"
        } years, and applying for the ${
          position ? position : "Software Engineer"
        } role. Ensure the answer is fully printed without truncation.`,
        api_call: apiCall,
        hash_session: generateHashSession(),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/fetch_questions`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response?.data?.question_answer_pairs) {
        setGenerateMoreQuestions((prev) => [
          ...prev,
          ...response?.data?.question_answer_pairs,
        ]);
      }

      setApiCall(apiCall + 1);
    } catch (error) {
      console.error(error, "*****Error in Adding More Questions*****");
      toast.error("Failed to add more questions", {
        style: { backgroundColor: "red", color: "white" },
      });
    } finally {
      setAddMoreLoading(false);
      setLoading(false);
      setShowSave(true);
    }
  };

  return (
    <>
      {(loading || regenLoading) && <Loading />}
      <div
        className="px-6  pt-6 pb-10 min-h-[calc(100vh-80px)]"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex justify-end gap-4 ">
          <span className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-3 rounded-lg shadow-md">
            Total Questions :{" "}
            {questions.length +
              customQuestions.length +
              generateMoreQuestions.length}
          </span>
        </div>

        <h2 className="text-2xl font-semibold my-6 text-white text-left">
          Set-Up Questions :
        </h2>

        <AnimatePresence>
          {questions.map((question, index) => (
            <motion.div
              key={index}
              className="flex items-center gap-3 bg-gray-100 px-4 py-3 rounded-lg shadow-md mb-4"
            >
              <span className="text-gray-700 font-medium">{index + 1}.</span>
              <span className="w-1/2">{question}</span>
            </motion.div>
          ))}
        </AnimatePresence>

        <AnimatePresence>
          {generateMoreQuestions.map((item, index) => (
            <DraggableQuestion
              key={item.id || index} // Ensuring key is unique
              id={item.id || index}
              index={index}
              question={item.question}
              options={item.options} // Pass options
              answer={item.answer} // Correct answer
              moveQuestion={moveQuestion}
              onChange={handleCustomChange}
              remove={removeGeneratedQuestion}
            />
          ))}
        </AnimatePresence>

        <AnimatePresence>
          {customQuestions.map((item, index) => {
            const questionNumber =
              questions.length + generateMoreQuestions.length + index + 1;
            return (
              <motion.div
                key={index}
                className="flex gap-4 w-full items-center mt-4 bg-white p-4 shadow-lg rounded-lg"
              >
                <span className="text-gray-700 font-medium">
                  {questionNumber}.
                </span>
                <textarea
                  placeholder="Enter question"
                  value={item.question}
                  onChange={(e) =>
                    handleCustomChange(
                      index,
                      "question",
                      e.target.value,
                      "custom"
                    )
                  }
                  className="w-1/2 px-4 py-2 border rounded-lg h-20"
                />
                <textarea
                  placeholder="Enter answer"
                  value={item.answer}
                  onChange={(e) =>
                    handleCustomChange(
                      index,
                      "answer",
                      e.target.value,
                      "custom"
                    )
                  }
                  className="w-1/2 px-4 py-2 border rounded-lg h-20"
                />
                <motion.button
                  onClick={() => removeCustomQuestion(index)}
                  className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg shadow-md  "
                >
                  Remove
                </motion.button>
              </motion.div>
            );
          })}
        </AnimatePresence>

        <div className="flex items-center gap-4 mt-6">
          <motion.button
            onClick={addCustomQuestion}
            className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md"
            draggable
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Add Custom Question
          </motion.button>

          {generateMoreQuestions && !generateMoreQuestions?.length > 0 && (
            <motion.button
              onClick={getdummyGeneratedQuestions}
              className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
              draggable
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              disabled={loading}
            >
              <i class="fa-solid fa-bolt"></i>
              {loading
                ? "Generating Questions through AI..."
                : "Generate Questions"}
            </motion.button>
          )}
          {showRegenerate && (
            <motion.button
              className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
              draggable
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={regenerateQuestions}
              disabled={regenLoading}
            >
              <i className="fa fa-redo"></i>
              {regenLoading
                ? "Re-Generating questions through AI..."
                : "Re-Generate question"}
            </motion.button>
          )}

          {generateMoreQuestions && generateMoreQuestions.length > 0 && (
            <motion.button
              className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 flex items-center gap-2 rounded-lg shadow-md"
              draggable
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={addMoreQuestions}
              disabled={addMoreLoading}
            >
              <i className="fa fa-plus"></i>
              {addMoreLoading
                ? "Generating More Questions through AI..."
                : "Add More Questions"}
            </motion.button>
          )}

          <motion.button
            className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 flex items-center gap-2 rounded-lg shadow-md"
            draggable
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate(`/setup-coding?id=${id}`)}
          >
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            Skip
          </motion.button>

          {generateMoreQuestions && generateMoreQuestions.length > 0 && (
            <motion.button
              className="bg-red-600 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setShouldReset(true)}
            >
              <i className="fa fa-undo"></i> Reset
            </motion.button>
          )}
        </div>
        <div className="mt-10 flex justify-center">
          {questions.length +
            customQuestions.length +
            generateMoreQuestions.length >
            0 &&
            showRegenerate &&
            showSave && (
              <motion.button
                className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
                draggable
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={AddQueAns}
              >
                <FaSave />
                Save
              </motion.button>
            )}
        </div>
        <div className=" p-2 flex justify-between items-center fixed bottom-8 left-0 right-0">
          <button
            className={`flex items-center gap-2 px-5 py-2  text-white rounded-lg font-medium transition-all bg-blue-700 hover:bg-blue-800`}
            onClick={prevStep}
          >
            <i className="fa fa-arrow-left"></i> Previous
          </button>

          <div className="flex gap-2">
            <motion.button
              className={`flex items-center gap-2 px-5 py-2 text-white  rounded-lg font-medium transition-all ${
                isSaveClicked
                  ? " bg-blue-700 hover:bg-blue-800"
                  : " bg-blue-400 cursor-not-allowed"
              }`}
              onClick={nextStep}
              disabled={!isSaveClicked}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Next <i className="fa fa-arrow-right"></i>
            </motion.button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SetUpInterview;
